import { COLORS } from 'app/constants'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text, View } from 'styles/reactnative'
import { useExchangeList } from '../../hooks/trade/exchangeList'
import { useFetcherPublic } from '../../hooks/fetcher'
import { useCurrency } from 'app/hooks/trade/useCurrency'

const KrwPrice = ({
	ep_id = undefined,
	price = 0,
	dp = undefined,
	style = {},
	won = '원',
}: any) => {

	const { krwrate } = useCurrency()

	return (
		<View style={{ lineHeight: 1, alignItems: 'flex-end' }}>
			<Text
				style={{
					justifyContent: 'flex-end',
					color:
						price > 0
							? COLORS.lightGreen
							: price == 0
							? 'black'
							: COLORS.lightRed,
					...style,
				}}>
				{BigNumber(price || 0).toFormat(0)}
				{won}
			</Text>
		</View>
	)
}

export default React.memo(KrwPrice)
